// Ujednolicone typy przeglądu - ŹRÓDŁO PRAWDY: mobile/src/types/inspection.ts
// Ten plik zapewnia spójność między aplikacją mobilną a panelem admina

// Statusy kontroli lokalu (używane w formularzu przeglądu) — pełny kanon 5 statusów jak na tablecie
// (zadanie 4, 2026-10-21: przegląd z papieru wprowadzany w panelu musi umieć zapisać obie odmowy).
export type InspectionStatus =
  | 'brak_dostepu'
  | 'odmowa_lokatora'
  | 'zalecenie'
  | 'brak_uwag'
  | 'odmowa_wpisu'
  | '';

// Próba dostępu (dla statusu 'brak_dostepu'). Kształt KANONICZNY (migracja 021+):
// { termNumber, status, date:'YYYY-MM-DD', note }. Pola legacy (pre-021)
// {attemptNumber, timestamp} są OPCJONALNE — starsze rekordy je noszą, a jedna
// tablica może MIESZAĆ oba kształty. Czytniki używają utils/attempts (tolerancja).
export interface InspectionAttempt {
  // Numer TERMINU BUDYNKU (I/II/III…), nie „które pukanie do tych drzwi" — zmiana 2026-07-28.
  // OPCJONALNY na ZAPISIE: gdy front go pominie, backend rozwiąże numer z `date` względem
  // harmonogramu w `inspections`. Odczytywane rekordy niosą go zawsze (migracja 041).
  termNumber?: number;
  status?: string | null; // status słownikowy próby (zwykle 'brak_dostepu')
  date: string; // 'YYYY-MM-DD'
  note?: string | null;
  /** legacy (pre-021) — tylko do odczytu starszych rekordów: */
  attemptNumber?: number;
  timestamp?: string;
}

// Mapowanie statusów localStorage → statusy lokali w budynku
export const mapInspectionStatusToApartmentStatus = (
  inspectionStatus: InspectionStatus
): 'not_scheduled' | 'scheduled' | 'completed' | 'no_access' | 'refused' => {
  if (inspectionStatus === 'brak_dostepu') return 'no_access';
  if (inspectionStatus === 'zalecenie' || inspectionStatus === 'brak_uwag') return 'completed';
  // Lustro LEGACY_FROM_CANON (backend utils/apartmentStatus.js): obie odmowy = 'refused'.
  if (inspectionStatus === 'odmowa_lokatora' || inspectionStatus === 'odmowa_wpisu') return 'refused';
  return 'not_scheduled';
};

// Helper do generowania numeru protokołu
export const generateProtocolNumber = (apartmentNumber: string): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const timestamp = now.getTime().toString().slice(-6);
  return `CEEB/${year}${month}${day}/${timestamp}/${apartmentNumber}`;
};
